import { render, staticRenderFns } from "./CouponRedemptionForm.vue?vue&type=template&id=bcd1b5f6&scoped=true"
import script from "./CouponRedemptionForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CouponRedemptionForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CouponRedemptionForm.vue?vue&type=style&index=0&id=bcd1b5f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd1b5f6",
  null
  
)

export default component.exports